import React, { useEffect, useState } from 'react'
import FormHeading from '../../UI_Design/FormComponents/Heading/FormHeading'
import { Routes, Route, Navigate, useNavigate, useParams } from 'react-router-dom';
import Tabs from './TabsAndContent/Tabs';
import Form11 from './TabsAndContent/Form11';
import Form2PartA from './TabsAndContent/Form2PartA';
import Form2PartB from './TabsAndContent/Form2PartB';
import FormF from './TabsAndContent/FormF';
import AdditionalDetails from './TabsAndContent/AdditionalDetails';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../Common/loader';
import { getOnboardingDetails } from '../../Actions/onboardingDetailsAction';
import { SAVE_ONBOARDING_DETAILS_SUCCESS } from '../../Constants/onboardingDetailsConstants';

const MainFormOnbording = () => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const tabs = [
  //   { name: 'FORM 11', path: 'form-11', content: <Form11 /> },
  //   { name: 'Form 2 (Part A)', path: 'form2-PartA', content: <Form2PartA /> },
  //   { name: 'Form 2 (Part B)', path: 'form2-PartB', content: <Form2PartB /> },
  //   { name: 'Form F', path: 'form-F', content: <FormF  /> },
  //   { name: 'Additional Details', path: 'Additional-Details', content: <AdditionalDetails /> },
  // ];
  let url = useParams();
  const [ allData, setAllData] = useState({});
  const [ tabs, setTabs] = useState([]);
  const [ isLoading, setIsLoading] = useState(false);


  // let tabs = [];

  const storeOnboardingData = useSelector((state) => state.onboardingDetail);
  const {onboardingDetailData, loading, error}=storeOnboardingData;

  const storeSaveOnboardingData = useSelector((state) => state.saveOnboardingData);
  const {saveOnboardingDetail, saveoading, Saveerror}=storeSaveOnboardingData;

  useEffect(() => {
    if(loading){
      setIsLoading(true);
    }else{
      setIsLoading(false);
    }
  },[loading])

  useEffect(()=>{
    let allTab = [];
      if (  typeof onboardingDetailData !== "undefined" && onboardingDetailData !== null && Object.keys(onboardingDetailData).length > 0){
        // setAllData(onboardingDetailData?.data?.tabDetails["EPF Nomination"]?.field_details);
        setIsLoading(true);
        Object.keys(onboardingDetailData?.data?.tabDetails)?.map((item, index) => {
          // allTab.push({ name: item , path: `${item.replaceAll(' ', '_',)}`, content: <Form11  tab={onboardingDetailData?.data?.tabDetails?.[item]}/> });
          if(item == 'FORM 11' || item == 'Form 11'){
            allTab.push({ name: item , path: `${item.replaceAll(' ', '_',)}`, content: <Form11  tab={onboardingDetailData?.data?.tabDetails?.[item]} tabId={onboardingDetailData?.data?.tab_array?.[item]} tabArr={onboardingDetailData?.data?.tab_array} nomineeArray={onboardingDetailData?.data?.nominee_array} referenceNo={onboardingDetailData?.data?.referenceNo} showProfilePreview={onboardingDetailData?.data?.showProfilePreview} /> });
          }else if(item == 'Form 2 (Part A)'){
            allTab.push({ name: item , path: `${item.replaceAll(' ', '_',)}`, content: <Form2PartA  tab={onboardingDetailData?.data?.tabDetails?.[item]} tabId={onboardingDetailData?.data?.tab_array?.[item]} tabArr={onboardingDetailData?.data?.tab_array} nomineeArray={onboardingDetailData?.data?.nominee_array} referenceNo={onboardingDetailData?.data?.referenceNo} showProfilePreview={onboardingDetailData?.data?.showProfilePreview} /> });
          }else if(item == 'Form 2 (Part B)'){
            allTab.push({ name: item , path: `${item.replaceAll(' ', '_',)}`, content: <Form2PartB tab={onboardingDetailData?.data?.tabDetails?.[item]} tabId={onboardingDetailData?.data?.tab_array?.[item]} tabArr={onboardingDetailData?.data?.tab_array} nomineeArray={onboardingDetailData?.data?.nominee_array} referenceNo={onboardingDetailData?.data?.referenceNo} showProfilePreview={onboardingDetailData?.data?.showProfilePreview} /> });
          }else if(item == 'Form F'){
            allTab.push({ name: item , path: `${item.replaceAll(' ', '_',)}`, content: <FormF tab={onboardingDetailData?.data?.tabDetails?.[item]} tabId={onboardingDetailData?.data?.tab_array?.[item]} tabArr={onboardingDetailData?.data?.tab_array} nomineeArray={onboardingDetailData?.data?.nominee_array} referenceNo={onboardingDetailData?.data?.referenceNo} showProfilePreview={onboardingDetailData?.data?.showProfilePreview} /> });
          }
          else{
            allTab.push({ name: item , path: `${item.replaceAll(' ', '_',)}`, content: <AdditionalDetails tab={onboardingDetailData?.data?.tabDetails?.[item]} tabId={onboardingDetailData?.data?.tab_array?.[item]} tabArr={onboardingDetailData?.data?.tab_array} nomineeArray={onboardingDetailData?.data?.nominee_array} referenceNo={onboardingDetailData?.data?.referenceNo} showProfilePreview={onboardingDetailData?.data?.showProfilePreview} /> });
          }

        })
        console.log(allTab,'tabs');
        setTabs(allTab);
        localStorage.setItem("CompanyIdOnboarding", onboardingDetailData?.data?.companyId);
        console.log(saveOnboardingDetail?.length != 0 && saveOnboardingDetail != undefined && saveOnboardingDetail?.data?.group != 'profile_preview');
        if(!(saveOnboardingDetail?.length != 0  && saveOnboardingDetail != undefined && saveOnboardingDetail?.data && saveOnboardingDetail?.data?.group?.group_id != 'profile_preview')){
          // navigate(`/onbordingDetailsInstaform/${allTab?.[0]?.path}`);
          navigate(`/case-initiation/check-detail/${onboardingDetailData?.data?.referenceNo}/11/${allTab?.[0]?.path}`);
        }
        setIsLoading(false);
      }
  },[onboardingDetailData, storeOnboardingData]);

  useEffect(() => {
    if(saveOnboardingDetail != undefined && saveOnboardingDetail?.data && saveOnboardingDetail?.data?.group?.group_id != 'profile_preview'){
      dispatch(getOnboardingDetails());
    }  
    // navigate(`/onbordingDetailsInstaform/${allTab?.[0]?.path}`);
  },[saveOnboardingDetail, storeSaveOnboardingData])


   
  return (
    <>
    {isLoading && <Loader />}
    <div className="p-3" style={{ background: "#F9FAFB" }}>
      <div className="formHeading">
        <FormHeading
          heading="Onboarding Details"
          subHeading="The below details will be used in your PF, Gratuity & other government statutory form. Please fill the correct information."
        />

        {/* tabs */}
        <div>
          <Tabs tabs={tabs} />
          <Routes>
            <Route path="/" element={<Navigate to="" />} />
            {tabs.map(tab => (
              <Route 
              key={tab.path}
              path={tab.path}
              // element={tab.path == 'form-11' ? tab.content : tab.content } 
              element={tab.content}
              />
            ))}
          </Routes>
        </div>
        {/* tabs */}

      </div>
    </div>
    </>
  )
}

export default MainFormOnbording